module.exports = __webpack_public_path__ + "121d944f9c5c98cd619ac0efd8b63c9e.png";